import React, { useState, useEffect, useMemo } from 'react';
import { useTheme  } from '../context/ThemeContext';
import { X, Search, Check } from 'lucide-react';
import './Chat/modalFilter.css'

const FilterModal = ({
  isOpen,
  onClose,
  documentLabels,
  documentFilters,
  onFilterChange,
  countChecked
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { isDarkMode, themeClass } = useTheme();
  
  // Handle click outside to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.classList.contains('modal-overlay')) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  // Normalize string for search (remove accents and make case insensitive)
  const normalizeString = (str) => {
    return str.normalize("NFD")
             .replace(/[\u0300-\u036f]/g, "")
             .toLowerCase();
  };

  // Filter and sort items based on search and selection
  const filteredAndSortedItems = useMemo(() => {
    const normalizedSearch = normalizeString(searchTerm);
    
    return Object.entries(documentLabels)
      .filter(([key, label]) => {
        if (!searchTerm) return true;
        return normalizeString(label).includes(normalizedSearch);
      })
      .sort((a, b) => {
        // Sort by selected status first
        const aSelected = documentFilters[a[0]] || false;
        const bSelected = documentFilters[b[0]] || false;
        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;
        return 0;
      });
  }, [documentLabels, documentFilters, searchTerm]);

  if (!isOpen) return null;
  const handleFilterChange = (event) => {
    onFilterChange(event);
    setSearchTerm(''); // Clear search after selection
  };
  return (
    <div className = {`modal-overlay-filter ${themeClass}`} >
      <div className = {`modal-content-filter ${themeClass}`}>
        {/* Header */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <h3 className={`filtrotitle ${themeClass}`}>Filtro de Leyes ({countChecked()} seleccionados)</h3>
          <button
            onClick={onClose}
            className={`closeFilter ${themeClass}`}
          >
            <X size={20} />
          </button>
        </div>

        {/* Search Bar */}
        <div className={`searchFilter ${themeClass}`}>
          <div className={`searchTextFilter ${themeClass}`}>
            <Search size={20} />
          </div>
          <input
            type ="text"
            placeholder="Buscar leyes..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
             className={`inputFilter ${themeClass}`}
          />
        </div>

        {/* Filters List */}
        <div style={{
          overflowY: 'auto',
          padding: '10px',
          flex: 1,
          marginBottom: '20px'
        }}>
          {filteredAndSortedItems.map(([key, label]) => (
            <div 
              key={key} 
              className = {`checkbox-wrapper-filter  ${themeClass}`} >
              <input
                type="checkbox"
                className="checkboxfilter"
                id={key}
                name={key}
                checked={documentFilters[key] || false}
                onChange={handleFilterChange}
              />
              <label className ={`labelito ${themeClass}`} htmlFor={key}>{label}</label>
            </div>
          ))}
        </div>
        <div className='alignbtn-filter'>
          <button
            onClick={onClose}
            className = {`login-button yellow ${themeClass}`}
          >
            <Check size={18} />
            Aceptar
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default FilterModal;